import { useState, lazy, Suspense } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import SEO from "@/components/SEO";

const Services = lazy(() => import("@/components/Services"));
const Remediation = lazy(() => import("@/components/Remediation"));
const CaseStudies = lazy(() => import("@/components/CaseStudies"));
const About = lazy(() => import("@/components/About"));
const Contact = lazy(() => import("@/components/Contact"));
const Footer = lazy(() => import("@/components/Footer"));
const ComplianceHealthCheck = lazy(() => import("@/components/ComplianceHealthCheck"));

const Index = () => {
  const [healthCheckOpen, setHealthCheckOpen] = useState(false);

  return (
    <>
      <SEO />
      <div className="min-h-screen bg-background">
      <Navbar onHealthCheck={() => setHealthCheckOpen(true)} />
      <main>
        <Hero onHealthCheck={() => setHealthCheckOpen(true)} />
        <Suspense fallback={null}>
          <Services />
          <Remediation onHealthCheck={() => setHealthCheckOpen(true)} />
          <CaseStudies />
          <About />
          <Contact />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <Footer />
        <ComplianceHealthCheck open={healthCheckOpen} onOpenChange={setHealthCheckOpen} />
      </Suspense>
    </div>
    </>
  );
};

export default Index;
